import styled from "styled-components";

const ConsentButtons = styled.div``;

export default ConsentButtons;
